import * as yup from 'yup';

export const signinSchema = yup.object().shape({

    username: yup.string().required(),

    password: yup.string().required()

});